// extracted by mini-css-extract-plugin
export default {"columns":"risk_columns__qellS","description":"risk_description__0J4sd","status":"risk_status__JtMsd","statsInfo":"risk_statsInfo__mlFYs"};